import React from 'react'

export const AdminProfile = () => {
  return (
    <h2 className='font-bold text-2xl'>AdminProfile</h2>
  )
}
